module.exports = __webpack_public_path__ + "static/media/row-level-security-icon.f9520899.svg";